import React from 'react'

const EtDeleteOrgUser = () => {
  return (
    <div>EtDeleteUser</div>
  )
}

export default EtDeleteOrgUser